import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AppInjector } from '@app/app.injector';
import { ButtonDefinition } from '@app/shared/types';
import { I18n } from '@app/i18n/strings-keys';
import { BaseComponent } from '../base-component';
import { FilterPanelUpdates, IFilter } from '../filter-panel/filter.types';

@Component({
  selector: 'xea-grid-header',
  templateUrl: './grid-header.component.html',
  styleUrls: ['./grid-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridHeaderComponent extends BaseComponent implements OnInit {
  @Input()
  public searchPlaceholder = I18n.CommonPlaceholders.Search;
  public searchText = '';

  @Input()
  public addBtn: ButtonDefinition = {
    caption: 'New',
    click: () => {},
  };

  @Input()
  public showFilters: boolean = false;

  @Input()
  public filters: IFilter[] = [];

  @Input()
  public refreshBtn: ButtonDefinition = {
    hidden: true,
    caption: 'Refresh',
    click: () => {},
  };

  @Output()
  public onSearch: EventEmitter<string> = new EventEmitter();

  @Output()
  public onApplyFilters: EventEmitter<FilterPanelUpdates> = new EventEmitter();

  @Output()
  public onFiltersCountChange: EventEmitter<number> = new EventEmitter();

  public constructor() {
    super(AppInjector.injector);
  }

  public ngOnInit() {}

  public onCreateNew(): void {
    this.addBtn?.click();
  }

  public onRefresh(): void {
    this.refreshBtn?.click();
  }

  public onSearchChange(value: string): void {
    // update value to search box
    this.searchText = value;

    this.onSearch.emit(value);

    this.cd.markForCheck();
  }

  public applyFilters(filterUpdates: FilterPanelUpdates): void {
    this.onApplyFilters.emit(filterUpdates);

    this.cd.markForCheck();
  }

  public filtersCountChange(count: number): void {
    this.onFiltersCountChange.emit(count);
  }
}
